import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import { FOOD_PARTNER_ORDER_PATH, MISC_REST_CONTENT_TYPE_APPLICATION_JSON, MISC_REST_CONTENT_TYPE_MULTIPART } from '../../core/constants';

export const updateAndSendFoodPartnerOrderAction = createAsyncThunk(
    'inventory/updateAndSendFoodPartnerOrderAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            let body = new FormData();
            const formJson = JSON.stringify(data.form);
            const formBlob = new Blob([formJson], {
                type: MISC_REST_CONTENT_TYPE_APPLICATION_JSON
            });

            body.append('form', formBlob);

            for (const attachment of data?.attachments) {
                body.append('attachments', attachment);
            }

            const response = await webClient.put(`${ FOOD_PARTNER_ORDER_PATH }/${ data.id }/save-and-send`, body, {
                headers: {
                    'content-type': MISC_REST_CONTENT_TYPE_MULTIPART
                }
            });
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateAndSendFoodPartnerOrderSlice = createSlice({
    name: 'updateAndSendFoodPartnerOrderSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateAndSendFoodPartnerOrderAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateAndSendFoodPartnerOrderAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateAndSendFoodPartnerOrderAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateAndSendFoodPartnerOrderState = (state) => state.inventory.updateAndSendFoodPartnerOrder;
export default updateAndSendFoodPartnerOrderSlice.reducer;
